import { getMethods as getDelegationController } from './Delegation';
import { getMethods as getGQLController } from './GQL';
import { getMethods as getMenuManagerController } from './MenuManager';
import { getMethods as getUserStartupController } from './UserStartup';
import { getMethods as getWebInterfaceManagementController } from './WebInterfaceManagement';
import { getMethods as getWorkflowController } from './Workflow';
import { getMethods as getWorkflowManagementController } from './WorkflowManagement';

const getController = (service: 'workflow') => ({
	workflowManagement: getWorkflowManagementController(service, 'workflowManagement'),
	Workflow: getWorkflowController(service, 'Workflow'),
	WebInterfaceManagement: getWebInterfaceManagementController(service, 'WebInterfaceManagement'),
	UserStartup: getUserStartupController(service, 'UserStartup'),
	Delegation: getDelegationController(service, 'Delegation'),
	MenuManager: getMenuManagerController(service, 'MenuManager'),
	gql: getGQLController(service, 'gql')
});

export { getController };
